import { Stack } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import WalletAltIcon from './../../assets/icons/WalletAlt.svg?react'

export const BalanceZeroDialog = ({ open, handleClose }) => {
    const navigate = useNavigate()

    const handleClickSubmit = () => {
        handleClose();
        navigate('/finances');
    }

    const handleClickClose = () => {
        handleClose()
    }

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickSubmit}
            handleClose={handleClickClose}
            submitButtonText="Пополнить баланс"
            colorSubmitButton="primary"
            title={
                <Stack
                    sx={{
                        background: '#006CFD',
                        borderRadius: '100px',
                        width: '40px',
                        height: '40px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    <WalletAltIcon color="#fff" />
                </Stack>
            }>
            <Typography variant="h4">Ваш баланс коинов исчерпан</Typography>
            <Typography variant="body2">
                Пополните баланс, чтобы получить доступ ко всему функционалу продукта
            </Typography>
        </ConfirmDialogWrapper>
    )
}
